(function() {
	angular.module('app', [
		'app.core',
		'app.layout',
		'app.services',
		'app.login',
		'app.logout',
		'app.register',
		'app.forgot',
		'app.reset',
		'app.invalidLogin',
        'app.constants',
        'app.mfaredirect',
		'ngCookies'
	]);
})();
